var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimAddToCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.07 7.95778C9.03503 7.95778 7.38503 6.31695 7.38503 4.28195C7.38503 3.63111 7.55919 2.98945 7.88003 2.43028H2.60919L2.58169 2.21028C2.47169 1.28445 1.68336 0.578613 0.748359 0.578613H0.620026C0.280859 0.578613 0.00585938 0.853613 0.00585938 1.19278C0.00585938 1.53195 0.280859 1.80695 0.620026 1.80695H0.757526C1.06919 1.80695 1.33503 2.03611 1.37169 2.34778L2.21503 9.54361C2.39836 11.0928 3.70919 12.2569 5.26753 12.2569H11.6842C12.0234 12.2569 12.2984 11.9819 12.2984 11.6428C12.2984 11.3036 12.0234 11.0286 11.6842 11.0286H5.26753C4.48836 11.0286 3.79169 10.5336 3.53503 9.80028H10.8592C12.3442 9.80028 13.6184 8.73695 13.8842 7.27028L14.0309 6.46361C13.3342 7.39861 12.2342 7.95778 11.07 7.95778Z",
    fill: "#858D9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.30506 15.337C4.98344 15.337 5.53339 14.7871 5.53339 14.1087C5.53339 13.4303 4.98344 12.8804 4.30506 12.8804C3.62667 12.8804 3.07672 13.4303 3.07672 14.1087C3.07672 14.7871 3.62667 15.337 4.30506 15.337Z",
    fill: "#858D9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4559 15.337C11.1343 15.337 11.6842 14.7871 11.6842 14.1087C11.6842 13.4303 11.1343 12.8804 10.4559 12.8804C9.77748 12.8804 9.22754 13.4303 9.22754 14.1087C9.22754 14.7871 9.77748 15.337 10.4559 15.337Z",
    fill: "#858D9D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.22754 4.88713H10.4559V6.11546C10.4559 6.45463 10.7309 6.72963 11.07 6.72963C11.4092 6.72963 11.6842 6.45463 11.6842 6.11546V4.88713H12.9125C13.2517 4.88713 13.5267 4.61213 13.5267 4.27296C13.5267 3.9338 13.2517 3.6588 12.9125 3.6588H11.6842V2.4213C11.6842 2.08213 11.4092 1.80713 11.07 1.80713C10.7309 1.80713 10.4559 2.08213 10.4559 2.4213V3.64963H9.22754C8.88837 3.64963 8.61337 3.92463 8.61337 4.2638C8.61337 4.61213 8.88837 4.88713 9.22754 4.88713Z",
    fill: "#858D9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimAddToCard);
export default __webpack_public_path__ + "static/media/dim-add-to-card.af775c84140394fc2924f01956295547.svg";
export { ForwardRef as ReactComponent };